/**
 * @generated SignedSource<<ae7dc98b84d7ea68ad1dd9e6fbcdb1c6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UpdateBaselineTemplateInput = {
  id: string;
  name: string;
  description?: string | null;
  includeDeliverables: boolean;
  phases: ReadonlyArray<BaselineTemplatePhaseInput>;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type BaselineTemplatePhaseInput = {
  name: string;
  startWeek: number;
  durationDays: number;
  deliverableName?: string | null;
  deliverableDescription?: string | null;
  timeEstimates: ReadonlyArray<BaselineTemplateTimeEstimateInput>;
  expenseEstimates: ReadonlyArray<BaselineTemplateExpenseEstimateInput>;
};
export type BaselineTemplateTimeEstimateInput = {
  roleId: string;
  minutes: number;
};
export type BaselineTemplateExpenseEstimateInput = {
  name: string;
  expenseCategoryId: string;
  revenue: number;
  cost: number;
};
export type UpdateBaselineTemplateMutation$variables = {
  input: UpdateBaselineTemplateInput;
};
export type UpdateBaselineTemplateMutation$data = {
  readonly updateBaselineTemplate: {
    readonly baselineTemplate: {
      readonly id: string;
      readonly name: string | null;
    } | null;
    readonly company: {
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"BaselineTemplatesList_company">;
    } | null;
  } | null;
};
export type UpdateBaselineTemplateMutation = {
  variables: UpdateBaselineTemplateMutation$variables;
  response: UpdateBaselineTemplateMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "BaselineTemplate",
  "kind": "LinkedField",
  "name": "baselineTemplate",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v3/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdateBaselineTemplateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateBaselineTemplatePayload",
        "kind": "LinkedField",
        "name": "updateBaselineTemplate",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "BaselineTemplatesList_company"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UpdateBaselineTemplateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateBaselineTemplatePayload",
        "kind": "LinkedField",
        "name": "updateBaselineTemplate",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "BaselineTemplate",
                "kind": "LinkedField",
                "name": "baselineTemplates",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "description",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "includeDeliverables",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "active",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "usageCount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "phaseCount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "deliverableCount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalMinutes",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "roleCount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "expenseLineCount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "updatedAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Person",
                    "kind": "LinkedField",
                    "name": "createdBy",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "fullName",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "63fb6f1a761b33bb97bbcaf725437e09",
    "id": null,
    "metadata": {},
    "name": "UpdateBaselineTemplateMutation",
    "operationKind": "mutation",
    "text": "mutation UpdateBaselineTemplateMutation(\n  $input: UpdateBaselineTemplateInput!\n) {\n  updateBaselineTemplate(input: $input) {\n    baselineTemplate {\n      id\n      name\n    }\n    company {\n      id\n      ...BaselineTemplatesList_company\n    }\n  }\n}\n\nfragment BaselineTemplatesList_company on Company {\n  baselineTemplates {\n    id\n    name\n    description\n    includeDeliverables\n    active\n    usageCount\n    phaseCount\n    deliverableCount\n    totalMinutes\n    roleCount\n    expenseLineCount\n    updatedAt\n    createdBy {\n      id\n      fullName\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f1e63b825a579f6ed9f1e204e623b59f";

export default node;
